import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Checkbox,
  TextField,
  Tooltip,
  Skeleton,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  fontfamily,
  primaryColor,
  primaryColorDark,
} from "../../Util/UtilColorPalate";


const bodyCellSx = { fontFamily: fontfamily, color: primaryColorDark };

const qtyFieldSx = {
  width: 80,
  "& .MuiOutlinedInput-root": {
    color: primaryColor,
    fontFamily: fontfamily,
    "& fieldset": { borderColor: primaryColor },
    "&:hover fieldset": { borderColor: primaryColor },
    "&.Mui-focused fieldset": { borderColor: primaryColor },
    "&.Mui-disabled fieldset": { borderColor: alpha(primaryColor, 0.4) },
  },
  "& input": { color: "black", textAlign: "center" },
  "& input.Mui-disabled": {
    WebkitTextFillColor: alpha(primaryColor, 0.5),
  },
};

const ProductTable = ({
  title,
  items = [],
  selected = {}, // { [recordid]: quantity }
  loading = false,
  lockQuantity = false, // bundles are always qty 1
  onToggle,
  onQuantityChange,
  onQuantityBlur,
}) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: fontfamily,
          fontWeight: "bold",
          color: primaryColorDark,
          mb: 1,
        }}
      >
        {title}
      </Typography>

      <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
        <Table size="small">
       

          <TableBody>
            {loading ? (
              [...Array(3)].map((_, i) => (
                <TableRow key={i}>
                  {[...Array(5)].map((__, j) => (
                    <TableCell key={j}>
                      <Skeleton variant="text" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : items.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{ ...bodyCellSx, color: "text.secondary" }}
                >
                  No {title} available
                </TableCell>
              </TableRow>
            ) : (
              items.map((item) => {
                const isSelected = selected[item.recordid] !== undefined;
                const description = (item.productdescription || "").replace(
                  /\/n/g,
                  "\n"
                );
                const price =
                  item.unitpriceinclvat ?? item.price ?? undefined;

                return (
                  <TableRow
                    key={item.recordid}
                    hover
                    selected={isSelected}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: alpha(primaryColor, 0.1),
                      },
                    }}
                  >
                    <TableCell sx={{ ...bodyCellSx, fontWeight: "bold" }}>
                      {item.name}
                    </TableCell>

                    <TableCell sx={{ ...bodyCellSx, maxWidth: 380 }}>
                      <Tooltip
                        title={
                          <span style={{ whiteSpace: "pre-line" }}>
                            {description}
                          </span>
                        }
                        arrow
                      >
                        <Typography
                          sx={{
                            fontFamily: fontfamily,
                            fontSize: "14px",
                            whiteSpace: "pre-line",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {description}
                        </Typography>
                      </Tooltip>
                    </TableCell>

                    <TableCell
                      align="right"
                      sx={{ ...bodyCellSx, whiteSpace: "nowrap" }}
                    >
                      {item.currency || "$"}{" "}
                      {price !== undefined ? Number(price).toFixed(2) : "-"}
                    </TableCell>

                    <TableCell align="center" sx={{ width: 110 }}>
                      <TextField
                        type="number"
                        size="small"
                        value={
                          lockQuantity
                            ? 1
                            : isSelected
                            ? selected[item.recordid]
                            : 1
                        }
                        disabled={!isSelected || lockQuantity}
                        onChange={(e) =>
                          onQuantityChange(item, e.target.value)
                        }
                        onBlur={(e) => onQuantityBlur(item, e.target.value)}
                        inputProps={{
                          min: 1,
                          step: 1,
                        }}
                        sx={qtyFieldSx}
                      />
                    </TableCell>

                    <TableCell align="center">
                      <Checkbox
                        checked={isSelected}
                        onChange={() => onToggle(item)}
                        inputProps={{ "aria-label": `Select ${item.name}` }}
                        sx={{
                          color: primaryColor,
                          "&.Mui-checked": { color: primaryColorDark },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ProductTable;